import APIService from './APIService';

export default {
  consultar(competenciaDe, competenciaAte, companies) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`consulta-aprovacoes-temas/consultar`, {
        params: {
          competencia_de: competenciaDe,
          competencia_ate: competenciaAte,
          companies: companies
        },
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  baixarConsultaDetalhada(competenciaDe, competenciaAte, companies, config) {
    return APIService.apiCall().get(`consulta-aprovacoes-temas/baixar-consulta-detalhada`, {
      params: {
        competencia_de: competenciaDe,
        competencia_ate: competenciaAte,
        companies: companies
      },
      responseType: 'blob',  
      ...config
    });
  },
}